/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const GraphicBannerFragment = {
  GraphicBanner: gql`
    fragment GraphicBannerQuery on graphicBanner2_Entry {
      typeHandle
    }
  `,
};

export const GlobalGraphicBannerFragment = {
  GlobalGraphicBanner: gql`
    fragment GlobalGraphicBannerQuery on graphicBanner_Entry {
      backgroundImage {
        url
        ... on images_Asset {
          altText
        }
      }
      altBgColor
      graphicBannerContent
      image {
        url
        ... on images_Asset {
          altText
        }
      }
      imageAligment
      promotionEndsDateTime
      promotionStartDateTime
      showHidePromoBanner
      styles
    }
  `,
};
